import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vp-date-header" }
const _hoisted_2 = { class: "vp-popover" }
const _hoisted_3 = { class: "vp-popover-note" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import moment from 'moment-timezone';

const TIMEZONE = 'America/Chicago';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceListDateHeader',
  props: {
    params: {}
  },
  setup(__props: any) {

const props = __props;

// AG Grid owns the sort state; mirror it so the arrow matches after any sort,
// including one triggered from another column.
const sort = ref<'asc' | 'desc' | null>(null);

const syncSort = () => {
  const { column } = props.params;
  sort.value = column.isSortAscending() ? 'asc' : column.isSortDescending() ? 'desc' : null;
};

onMounted(() => {
  syncSort();
  props.params.column.addEventListener('sortChanged', syncSort);
});

onBeforeUnmount(() => {
  props.params.column.removeEventListener('sortChanged', syncSort);
});

const onSortClick = (event: MouseEvent) => {
  if (!props.params.enableSorting) return;
  props.params.progressSort(event.shiftKey);
};

const boundaryText = computed(() =>
  props.params.boundary === 'start'
    ? 'Start date is fully included in the price list, considering Chicago timezone.'
    : 'End date is fully included in the price list, considering Chicago timezone.',
);

// Recomputed each time the popover opens — a value captured at mount would go
// stale on a page left open, which is exactly when someone checks the clock.
const currentChicagoTime = ref('');
const onToggle = (isOpen: boolean) => {
  if (isOpen) currentChicagoTime.value = moment().tz(TIMEZONE).format('MMMM D, YYYY h:mm A');
};

return (_ctx: any,_cache: any) => {
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "vp-date-header-label",
      onClick: onSortClick
    }, _toDisplayString(_ctx.params.displayName), 1),
    (sort.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["ag-icon", sort.value === 'asc' ? 'ag-icon-asc' : 'ag-icon-desc']),
          onClick: onSortClick
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode(_component_v_menu, {
      location: "bottom",
      offset: 4,
      "open-on-hover": "",
      "open-delay": 200,
      "close-delay": 300,
      "onUpdate:modelValue": onToggle
    }, {
      activator: _withCtx(({ props: menuProps }) => [
        _createElementVNode("i", _mergeProps(menuProps, {
          class: "mdi mdi-information-outline vp-date-header-info",
          "aria-label": "About these dates",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }), null, 16)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(boundaryText.value), 1),
          _createElementVNode("div", _hoisted_3, "Current Chicago time: " + _toDisplayString(currentChicagoTime.value), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})